import React from 'react'
import { connect } from 'react-redux'
import { setSection } from '../actions'
import ToggleLayer from './ToggleLayer'
import $ from "jquery";

let ToggleMenu = ({ id, item, itemChildren, dispatch }) => {

  return (
   <li className="">
    <a href="" className="menu-item-primary" id={ item.id + '-primary' } onClick={e => {
      e.preventDefault()
      $('.layer-detail').hide()
      $('.secondary').hide()
      dispatch(setSection(item.id))
      $('#' + id).show()
    }} >{ item.title }</a>
    <ul id={ id } className="secondary">
    { itemChildren.map((child, i) =>
      <ToggleLayer
        key={i}
        item={ child }
        section={ id }
        exclusive={ child.exclusive }
        group={ child.group }
        id={ child.id }
        title={ child.title }
        children={ child.children } />
    )}
    </ul>
   </li>
  )
}
ToggleMenu = connect()(ToggleMenu)

export default ToggleMenu



// WEBPACK FOOTER //
// ./src/containers/ToggleMenu.js